import { render, staticRenderFns } from "./TecnicosEditar.vue?vue&type=template&id=73270b85"
import script from "./TecnicosEditar.vue?vue&type=script&lang=js"
export * from "./TecnicosEditar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports